/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {ColorHex} from '../../enum/color/color-hex.enum';
import {ColorRGB} from '../../enum/color/color-rgb.enum';

export class BadgeIcon {
  public color: string;
  public backgroundColor: string;
  public text: string;

  constructor(name: string) {
    this.text = name.split(' ').map(t => t.length > 0 ? t.charAt(0) : '').join('');
    this.text = this.text.slice(0, 3);
    let count = 0;
    for (let i = 0; i < this.text.length; ++i) {
      count += this.text.charCodeAt(i);
    }
    this.color = ColorHex[count % 7];
    this.backgroundColor = `rgba(${ColorRGB[count % 7]},0.2)`;
  }
}
